<template>
    <div class="throbber-overlay">
        <div class="loading"
             v-bind:class="{
                            'full': display === 'full' || !display,
                            'toast': display === 'toast',
                            'inline': display === 'inline',
                        }"
        >
            <span class="throbber"><i class="fas fa-circle-notch fa-spin"></i></span>
            <span class="throbber-message" v-if="message" v-html="message"></span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .throbber-overlay {
        .loading {
            margin: 1em 0;

            &.full {
                margin: 0;
                bottom: 0;
                align-items: center;
                justify-content: center;
                display: flex;
                font-size: 2em;
                left: 0;
                position: absolute;
                right: 0;
                top: 0;
                z-index: 1000;

                background: rgba(255, 255, 255, 0.6);

                .throbber-message {
                    display: block;
                }
            }

            &.toast {
                position: fixed;
                bottom: 0.5em;
                left: 50%;
                transform: translateX(-50%);
                background: black;
                color: white;
                border-radius: 4px;
                padding: 0.25em 0.75em;
                z-index: 100;
            }

            .throbber-message {
                font-style: italic;
            }
        }
    }

</style>


<script>
    export default {
        props: {
            message: {
                type: String,
                default: null,
            },
            display: {
                type: String,
                default: "full",
            },
            startHidden: {
                type: Boolean,
                default: false,
            },
        },
        mounted() {
            if (this.startHidden) {
                this.$el.style.display = 'none';
            }
        },
        methods: {
            show: function() {
                this.$el.style.display = '';
            },
            hide: function() {
                this.$el.style.display = 'none';
            }
        }
    }
</script>
